export const formatRolesToSelectDataFormat = (roles) => {
    return roles.reduce((acc, role) => {
        const newRole = {
            ...role,
            value: role.id,
        };
        return [...acc, newRole];
    }, []);
};
